import { useEffect, useRef } from 'react';
import { useRouter } from 'next/router';

import downloadFn from '@/utils/downloadNew';

import css from './index.module.scss';

export default function Sidebar() {
  const router = useRouter();

  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const tempTemplate = `
      <wx-open-launch-app
        id="launch-btn"
        appid="wx1f612f478c038590"
        extinfo=${process.env.NEXT_PUBLIC_API_PRO + router.asPath}
        style="position: absolute;top: 0;left: 0; right: 0; bottom: 0;"
      >  
        <script type="text/wxtag-template">
          <style>.btn { width: 100%; height: 50px;}</style>
          <div class="btn"></div>
        </script>
      </wx-open-launch-app>
    `;
    const current = ref.current;
    if (current) current.innerHTML = tempTemplate;

    const btn = document.getElementById('launch-btn');
    if (btn) {
      btn.addEventListener('launch', function () {
        console.log('success');
      });
      btn.addEventListener('error', function (e) {
      // "launch:fail"	当前场景不支持跳转，或Android上该应用未安装，或iOS上用户在弹窗上点击确认但该应⽤未安装
      //  支持的场景有以下四个：
      // 1. 公众号菜单栏
      // 2. 微信收藏
      // 3. app sdk 分享出来的卡片
      // 4. 二次分享的卡片
        console.log('fail', e);
      });
    }
    
  }, []);
  
  const openApp = () => {
    const herfs = [
      `${process.env.NEXT_PUBLIC_OPEN_ANDROID}${document.location.pathname + document.location.search}.html`,
      `${process.env.NEXT_PUBLIC_OPEN_IOS}${document.location.pathname + document.location.search}.html?download=1`
    ];
    downloadFn(navigator.userAgent, herfs);
  }

  return (
    <div className={css.headerWrap} onClick={openApp}>
      <a className={css.header}>
        {/* eslint-disable-next-line @next/next/no-img-element */}
        <img className={css.logo} src='/images/guide_hx_logo.png' alt='妙投logo' />
        <h1>妙投 助你财富与认知同步升级</h1>
        <div className={css['go']}>
          <span>GO!</span>
          <div ref={ref}></div>
        </div>
      </a>
      <div className={css.pcQrImg}>
        {/* eslint-disable-next-line @next/next/no-img-element */}
        <img
          src={process.env.NEXT_PUBLIC_IMAGE_CDN + '/miaotou/yingyongbao_download.png'}
          alt='扫码打开妙投App'
        />
        <p>扫码打开妙投App</p>
      </div>
    </div>
  );
}
